export default function Contact() {
  return (
    <div>
      <h1 className="text-center text-4xl bg-black py-2 mb-8 text-white">Contact</h1>
    </div>
  );
}
